import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'processingStatusPipe'
})
export class ProcessingStatusPipe implements PipeTransform {
  private baseClass = 'fa fa-circle fa-1x ';

  transform(input: string, args?: any): string {
    let textColor = 'orange-text';

    if (
      input === 'ACTIVE' ||
      input === 'PENDACTIVE' ||
      input === 'COMPLETED' ||
      input === 'OPEN' ||
      input === 'N'
    ) {
      textColor = 'green-text';
    } else if (
      input === 'INCOMPLETE' ||
      input === 'CANCELLED' ||
      input === 'SUSPEND' ||
      input === 'CLOSED' ||
      input === 'Y'
    ) {
      textColor = 'red-text';
    } else if (input === 'STARTED') {
      textColor = 'yellow-text';
    } else if (input === 'PENDING') {
      textColor = 'orange-text';
    }

    return this.baseClass + textColor;
  }
}
